import React, { Component } from "react";
import { connect } from "react-redux";

import Maps from "./maps.component";

class MapWithContainer extends Component {
    constructor(props) {
        super(props);
    }

    hideMap() {
        this.props.closeMap();
    }

    render() {
        return (
            <div className="row">
                <div className="maps-container" >
                    <div className="map">
                        <div className="row header-container">
                            <div className="title col">{this.props.title}</div>
                            <div className="close-button col-1" onClick={() => this.hideMap()}>X</div>
                        </div>
                        <Maps isMarkerShown={true} lat={Number(this.props.coordinates.lat)} lng={Number(this.props.coordinates.lng)} />
                        <div className="address">Adresă: {this.props.address}</div>
                        <div className="phone">Telefon: {this.props.phone}</div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, {})(MapWithContainer);


// WEBPACK FOOTER //
// ./src/SHARED/components/maps/mapwithcontainer.js